































































































import { Component, Prop } from 'vue-property-decorator';
import { CircleIcon, DiscIcon, UploadIcon } from 'vue-feather-icons';
import dayjs from 'dayjs';
import {
  FivGoalGroupType,
  GetGoalGroupDto,
  IFivGoal,
  IFivGoalGroup,
  IUploadBusinessPlanReport,
  IUser,
  UserSpecialType,
} from 'admiral-core';
import BusinessPlanReportCard from '@/views/pages/fivgoals/BusinessPlanReportCard.vue';
import { BusinessPlanApi } from '@/services/BusinessPlanApi';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { FivApi } from '@/services/FivApi';

@Component({ components: { UserSelect, BusinessPlanReportCard, CircleIcon, DiscIcon, UploadIcon } })
export default class BusinessPlanReportConfirmation extends mixins(BaseMixin) {
  @Prop({ type: Object })
  uploadedBusinessPlanReport!: IUploadBusinessPlanReport;

  @Prop({ required: false, type: Array })
  businessPlanReportGoals!: IFivGoal[];

  @Prop({ required: false, type: Object })
  goalGroup!: IFivGoalGroup;

  reportFiles = '';

  get formatReportDate() {
    return dayjs(this.uploadedBusinessPlanReport?.report?.reportDate).format('DD.MM.YYYY');
  }

  get formatDataDate() {
    return dayjs(this.uploadedBusinessPlanReport?.report?.dataDate).format('DD.MM.YYYY');
  }

  get incomplete() {
    return this.uploadedBusinessPlanReport?.status === 'incomplete';
  }
  get error() {
    return this.uploadedBusinessPlanReport?.status === 'error';
  }

  get errorMessage() {
    return this.uploadedBusinessPlanReport.error;
  }
  cancel() {
    this.$emit('cancel');
  }

  isSavable() {
    return this.uploadedBusinessPlanReport?.status === 'completed';
  }
  async ok() {
    try {
      if (this.uploadedBusinessPlanReport.report) {
        const newReport = await BusinessPlanApi.createBusinessPlanReport({
          businessPlanReport: this.uploadedBusinessPlanReport.report,
        });
        this.$emit('done', newReport.data);
      }
    } catch (e) {
      this.$emit('cancel');

      this.$toastr.e('Beim Speichern des Geschäftsplans ist etwas schief gelaufen.');
      throw e;
    }
  }
  async handleMoreReportFileUpload() {
    this.reportFiles = (this.$refs['reportfile'] as HTMLFormElement).files;
    const formData = new FormData();

    for (let i = 0; i < this.reportFiles.length; i++) {
      formData.append('file' + i, this.reportFiles[i]);
    }

    try {
      const responseUpload = await BusinessPlanApi.uploadBusinessPlanReport(
        this.goalGroup!.id,
        formData,
      );

      this.uploadedBusinessPlanReport.parts = this.uploadedBusinessPlanReport.parts?.concat(
        responseUpload.data[0],
      );

      const responseValidate = await BusinessPlanApi.validateUploadedBusinessPlanReport(
        this.uploadedBusinessPlanReport,
      );

      this.$emit('updateBusinessPlan', responseValidate.data);

      (this.$refs['reportfile'] as HTMLFormElement).value = '';
    } catch (e) {
      this.$toastr.e('Beim Hochladen des Geschäftsplans ist etwas schief gelaufen.');
      throw e;
    }
  }

  get hasUserSelection() {
    return (
      !this.uploadedBusinessPlanReport.report?.goalGroup ||
      (this.uploadedBusinessPlanReport.report.goalGroup.user &&
        this.uploadedBusinessPlanReport.report.goalGroup.user.id !== this.user.id)
    );
  }
  async updateUser(user: IUser) {
    const goalGroupDto: GetGoalGroupDto = {
      groupType: FivGoalGroupType.BusinessPlanPlus,
      year: this.fivGoalsFilter.year,
      user,
    };
    const response = await FivApi.getGoalGroup(goalGroupDto);
    if (this.uploadedBusinessPlanReport.report) {
      this.uploadedBusinessPlanReport.report.goalGroup = response.data;
    }
  }
  get kbvUsers() {
    return this.users.filter((user: IUser) => user.type === UserSpecialType.Kbv);
  }
}
